import React from "react";
import { useDispatch } from "react-redux";
import { FaChevronRight } from "react-icons/fa";
import { updateShowAddonsDrawer } from "../../../reducer/bookingReducer";

const AddOnsContainer = () => {
  const dispatch = useDispatch();

  return (
    <div
      className="flex p-[16px] mx-[16px] cursor-pointer justify-between items-center 
    border-[1px]  border-brand-border-muted rounded-[12px] flex-1 w-[50%]"
      onClick={() => dispatch(updateShowAddonsDrawer(true))}
    >
      <div className=" whitespace-nowrap font-[500] text-[18px] leading-[22.68px] text-fg">
        Add Add-ons
      </div>

      <FaChevronRight className="text-[20px] text-primary" />
    </div>
  );
};
export default AddOnsContainer;
